export default function Header() {
  return (
    <header>
      <div className="container">
        <span className="custom_icon__wrap">
          Todo app <span className="material-icons custom_icon">apps</span>
        </span>
      </div>
    </header>
  );
}
